module.exports = __webpack_public_path__ + "static/img/selecticon.e676f088.svg";